import React from "react";
import AuthLayout from "./AuthLayout";
import PartnerPortalSignInLayout from "./PartnerPortalSignInLayout";
import { getSellerOrgBuildConfig, isPartnerAuthLayout } from "../../../config/sellerOrgConfig";

export interface AuthShellProps {
  children: React.ReactNode;
  disableCustomTheme?: boolean;
}

/**
 * Single decision point for unauthenticated auth shells (login, registration).
 */
const AuthShell: React.FC<AuthShellProps> = ({ children, disableCustomTheme }) => {
  const config = getSellerOrgBuildConfig();

  if (isPartnerAuthLayout(config)) {
    return (
      <PartnerPortalSignInLayout disableCustomTheme={disableCustomTheme}>
        {children}
      </PartnerPortalSignInLayout>
    );
  }

  return <AuthLayout disableCustomTheme={disableCustomTheme}>{children}</AuthLayout>;
};

export default AuthShell;
